import styled from "styled-components";

export const Container = styled.main`

  .inner{
    max-width: 360px;
    padding-top: 100px;
    padding-bottom: 100px;

    .form_label{
      margin-top: 36px;
    }
    
    .pay_method{
      margin-bottom: 24px;
      button{
        width: 100%;
        height: 46px;
        border-radius: 6px;
  
        &.active{
          border-color: var(--main);
          color: var(--main_hover);
        }
  
        + button{
          margin-left: 12px;
        } 
      }
      .description{
        margin-top: 12px;
  
        p, span{
          line-height: 1.5;
          font-size: 12.5px;
        }
  
        p+p{
          margin-top: 6px;
        }
      }
    }

    .btn_pay{
      width: 100%;
      height: 46px;
      margin: 60px 0 0;
      border-radius: 6px;
      font-family: 'PretendardBold';
    }
  }
`